import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../lib/cn';

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  className,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  function goTo(p) {
    if (p < 1 || p > totalPages || p === page) return;
    onPageChange?.(p);
  }

  function pages() {
    const out = [];
    const window = 1;
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= page - window && i <= page + window)
      ) {
        out.push(i);
      } else if (out[out.length - 1] !== '...') {
        out.push('...');
      }
    }
    return out;
  }

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 px-1 py-3',
        className
      )}
    >
      <span
        className="text-[11px] tabular-nums"
        style={{ color: 'var(--dash-text-muted)' }}
      >
        {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} de {total}
      </span>
      <div className="flex items-center gap-1">
        <PageButton onClick={() => goTo(page - 1)} disabled={page === 1}>
          <ChevronLeft size={14} />
        </PageButton>
        {pages().map((p, i) =>
          p === '...' ? (
            <span
              key={`dot-${i}`}
              className="px-1.5 text-xs"
              style={{ color: 'var(--dash-text-faint)' }}
            >
              …
            </span>
          ) : (
            <PageButton key={p} active={p === page} onClick={() => goTo(p)}>
              {p}
            </PageButton>
          )
        )}
        <PageButton
          onClick={() => goTo(page + 1)}
          disabled={page === totalPages}
        >
          <ChevronRight size={14} />
        </PageButton>
      </div>
    </div>
  );
}

function PageButton({ children, active, disabled, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex h-8 min-w-8 items-center justify-center rounded-lg px-2 text-xs font-medium tabular-nums transition-all duration-150 disabled:cursor-not-allowed disabled:opacity-40"
      style={{
        background: active ? 'var(--dash-primary-soft)' : 'transparent',
        color: active ? 'var(--dash-primary)' : 'var(--dash-text-soft)',
        border: active
          ? '1px solid var(--dash-primary-border)'
          : '1px solid transparent',
      }}
      onMouseEnter={(e) => {
        if (!disabled && !active)
          e.currentTarget.style.background = 'var(--dash-surface-hover)';
      }}
      onMouseLeave={(e) => {
        if (!active) e.currentTarget.style.background = 'transparent';
      }}
    >
      {children}
    </button>
  );
}
